import React from 'react'
import { formatCurrency, transformWriteOffs } from "../../utils/commonutils";
import { Button, Icon, Label, Modal, Table } from "semantic-ui-react";
import { sendReport } from "../../redux/modules/billing";
import SummaryCodeAmountChips from "./SummaryCodeAmountChips";

const headers = [{
    "header": "Practice",
    get: (item, getPracticeName) => getPracticeName(item.Practice)
}, {
    "header": "Patient #",
    get: (item) => item.PatNum
}, {
    "header": "Date of Service",
    get: (item) => item.ProcDate
}, {
    "header": "Entry Date",
    get: (item) => item.DateEntry
}, {
    "header": "Carrier",
    get: (item) => item.CarrierName
}, {
    "header": "Procedure Code",
    get: (item) => item.ProcCode
}, {
    "header": "WO Code",
    get: (item) => item.Writeoff_Code
}, {
    "header": "WO Amount",
    get: (item) => <b>{formatCurrency(item.WriteOff)}</b>
}, {
    "header": "WO Note",
    get: (item) => item.Writeoff_Note
}, {
    "header": "WO Description",
    get: (item) => item.Writeoff_Description
}];


function CalendarWriteOffs(props) {
    const [open, setOpen] = React.useState(false);
    const [sort, setSort] = React.useState([headers[2].header, true]);
    const [data, setData] = React.useState([]);
    const abbr = props.providerPayByPractice?.ABBR;
    const groupedWriteOffs = transformWriteOffs(props.payData?.writeOffGroupByDentistByPractice?.[abbr]);
    const adjWoProcDateStart = props.providerPayByPractice?.doctorPayVariables?.GreaterofAdjWOProcdateStart;

    React.useEffect(() => {
        sortData();
    }, [sort, props.payData])

    React.useEffect(() => {
        sortData();
    }, [])

    const sortData = React.useCallback(() => {
        const header = headers.find(h => h.header === sort[0]);
        const multiplicand = sort[1] ? 1 : -1;
        const data = Object.values(groupedWriteOffs?.data ?? {})
            .map(p => Object.values(p.data))
            .flat(2)
            .sort((a, b) => {
                if (header.header === "WO Amount") return (a.WriteOff - b.WriteOff) * multiplicand;
                return header?.get(a, props.getPracticeName)?.toString()?.localeCompare(header.get(b, props.getPracticeName)) * multiplicand;
            });
        setData(data);
    }, [sort, groupedWriteOffs]);

    const send = () => {
        const { dispatch, user } = props;
        dispatch(sendReport({
            detailsModalType: 'writeoff',
            detailsModal: 'report',
            eventClick: 'month',
            mtdBillable: '',
            productionPrice: false,
            eventDate: false,
            startDate: props.startDate,
            abbr: user.UdaDrList.abbr,
            prodAdjWo: user.UdaDrList.prodAdjWo
        }))
            .catch((err) => {
                console.log('Err =====>>>>> ', err);
                alert('Email sending failed. Please try again.');
            });
        setOpen(false);
        alert('Sending email...');
    }

    return <Modal
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
        open={open}
        size='large'
        closeIcon={true}
        trigger={<span>
            WriteOffs: <b>{formatCurrency(groupedWriteOffs?.price ?? 0)}</b>
        </span>}
    >
        <Modal.Header>
            {props.providerPayByPractice?.doctorName}
            <Label
                basic={true}
                color="purple"
                detail="WriteOffs"
                content={formatCurrency(groupedWriteOffs?.price ?? 0)}
            />
            {adjWoProcDateStart && (
                <Label
                    className="ml-3"
                    content={`Proc Date ≥ ${adjWoProcDateStart}`}
                    detail="Filter Active"
                    color="orange"
                    size="small"
                />
            )}
            <SummaryCodeAmountChips title="Write Off codes summary:" name="Writeoff_Code" value="WriteOff" data={data ?? []} />
        </Modal.Header>
        <Modal.Content>
            <div className="table-responsive FreezeTable">
                <Table striped={true} size="small">
                    <Table.Header>
                        <Table.Row>
                            {headers.map(h => <Table.HeaderCell
                                className={`cursorPointer ${sort[0] === h.header ? 'active' : ''}`}
                                onClick={() => setSort([h.header, !sort[1]])}
                            >
                                <Icon
                                    name={`sort content ${sort[1] && sort[0] === h.header ? 'ascending' : 'descending'}`}
                                    color={sort[0] === h.header ? 'orange' : 'grey'}
                                    style={{ cursor: 'pointer' }}
                                />
                                {h.header}
                            </Table.HeaderCell>)}
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {
                            data?.map((item, index) => (<Table.Row key={index}>
                                {headers.map(h => <Table.Cell content={h.get(item, props.getPracticeName)} />)}
                            </Table.Row>))
                        }
                        {
                            data?.length > 0 && <Table.Row>
                                <Table.Cell content={<b>Total</b>} colSpan={7} />
                                <Table.Cell colSpan={2} content={<b>{formatCurrency(groupedWriteOffs?.price ?? 0)}</b>} />
                            </Table.Row>
                        }
                        {
                            data?.length === 0 &&
                            <Table.Row><Table.Cell content="No Data" colSpan={headers.length} /></Table.Row>
                        }
                    </Table.Body>
                </Table>
            </div>
        </Modal.Content>
        <Modal.Actions>
            <Button primary onClick={() => send()}>Send Report</Button>
            <Button onClick={() => setOpen(false)}>Close</Button>
        </Modal.Actions>
    </Modal>;
}


export default CalendarWriteOffs